import CountUp from "react-countup";

import { formatCurrency, formatNumber, formatPercent } from "@/utils/finance";

import { RESULT_TYPES } from "@/utils/calculatorSchema";

export default function AnimatedValue({
  value,
  type = RESULT_TYPES.NUMBER,
  duration = 0.6,
}) {
  if (value === null || value === undefined) {
    return "-";
  }

  // If a pre-formatted display string is supplied,
  // render it directly without animation.
  if (typeof value === "string") {
    return value;
  }

  const number = Number(value);

  if (!Number.isFinite(number)) {
    return "-";
  }

  switch (type) {
    case RESULT_TYPES.CURRENCY:
      return (
        <CountUp
          end={number}
          duration={duration}
          preserveValue
          formattingFn={formatCurrency}
        />
      );

    case RESULT_TYPES.PERCENT:
      return (
        <CountUp
          end={number}
          decimals={2}
          duration={duration}
          preserveValue
          formattingFn={formatPercent}
        />
      );

    case RESULT_TYPES.NUMBER:
    default:
      return (
        <CountUp
          end={number}
          duration={duration}
          preserveValue
          formattingFn={formatNumber}
        />
      );
  }
}
